import React from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';

const ResponsiveContainer = ({
  children,
  maxWidth = 'xl',
  disableGutters = false,
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container
      maxWidth={maxWidth}
      disableGutters={isMobile ? true : disableGutters}
      sx={{
        px: isMobile ? 1 : 3,
        py: isMobile ? 1 : 2,
        ...sx
      }}
      {...props}
    >
      {children}
    </Container>
  );
};

export default ResponsiveContainer;